// Lib
import React, { ReactElement } from 'react';

// Styles
import './AiModeHeading.scss';

interface AiModeHeadingProps {
    children: string | ReactElement;
}

const AiModeHeading = (props: AiModeHeadingProps): ReactElement => {
    const { children } = props;
    return <h2 className="AiModeHeading">{children}</h2>;
};

export default AiModeHeading;
